module.exports = __webpack_public_path__ + "media/images/flags/kn-d7f58eca10ca8fa909b3b4f215ffc38e.svg";